export default __webpack_public_path__ + "static/media/news82.dc6e4f0b.jpg";